import React from "react";
import { Link } from "react-router-dom";
import useMobile from "../Hook/UseMobile";
import { FaChevronRight } from "react-icons/fa6";

function PartnersNewsletter() {
	const isMobile = useMobile();

	return (
		<div className="newsletter">
			<h2 className="newsletter__title">
				Rejoindre la newsletter{" "}
				<strong>
					<i>Parlons Règles</i>
				</strong>
			</h2>
			{!isMobile && (
				<Link to="https://forms.fillout.com/t/n4hXgK1PEzus" className="newsletter__button focused" target="_blank" rel="noreferrer">
					S'abonner à la newsletter{" "}
					<FaChevronRight className="partners-footer__chevron" />
				</Link>
			)}
			{isMobile && (
				<Link to="https://forms.fillout.com/t/n4hXgK1PEzus" className="newsletter__button">
					S'abonner à la newsletter{" "}
					<FaChevronRight className="partners-footer__chevron" />
				</Link>
			)}
		</div>
	);
}

export default PartnersNewsletter;
